import { LoaderFunctionArgs } from "react-router-dom";
import { lecturerManageCoursesUpdateFormLoaderDTO } from "../types/manageCourseInfoTypes";
import { apiEndpoints } from "@/services/api/api";

export async function manageCourseInfoLoader({
  params,
}: LoaderFunctionArgs): Promise<lecturerManageCoursesUpdateFormLoaderDTO> {
  const courseId = params.courseId;
  if (!courseId) {
    throw new Error("courseId parametresi eksik");
  }
  try {
    const [courseResponse, tagsResponse, categoriesResponse] =
      await Promise.all([
        apiEndpoints.lecturerGetCourseInfo(courseId),
        apiEndpoints.getTagsForFilter(),
        apiEndpoints.getCategoriesForFilter(),
      ]);
    if (!courseResponse.success) {
      throw new Error(courseResponse.message || "Kurs bilgisi alınamadı");
    }
    if (!tagsResponse.success) {
      throw new Error(tagsResponse.message || "Tag bilgileri alınamadı");
    }
    if (!categoriesResponse.success) {
      throw new Error(
        categoriesResponse.message || "Kategori bilgileri alınamadı"
      );
    }
    // Backend'den gelen ISO datetime formatını YYYY-MM-DD formatına çevir
    const course = courseResponse.data;
    if (course.startDate) {
      const startDate = new Date(course.startDate);
      const year = startDate.getFullYear();
      const month = String(startDate.getMonth() + 1).padStart(2, "0");
      const day = String(startDate.getDate()).padStart(2, "0");
      course.startDate = `${year}-${month}-${day}`;
    }
    if (course.endDate) {
      const endDate = new Date(course.endDate);
      const year = endDate.getFullYear();
      const month = String(endDate.getMonth() + 1).padStart(2, "0");
      const day = String(endDate.getDate()).padStart(2, "0");
      course.endDate = `${year}-${month}-${day}`;
    }

    const result: lecturerManageCoursesUpdateFormLoaderDTO = {
      course: course,
      tags: tagsResponse.data,
      categories: categoriesResponse.data,
    };

    return result;
  } catch (error) {
    console.error("Error loading course info:", error);
    throw new Error("Kurs içeriği yüklenemedi");
  }
}
